<div class="ipm-dhp">
    <ipm-diwali-sparkles class="ipm-dhp-sparkles" aria-hidden="true"></ipm-diwali-sparkles>

    <div class="ipm-dhp-head">
        <h2 class="ipm-dhp-title">
            <span class="ipm-dhp-brand">Beat22</span>
            <span class="ipm-dhp-diwali" *ngIf="!isLive">Diwali</span>
            <!-- sale live: the last letter is an anar (flower-pot firecracker) spraying sparks -->
            <span class="ipm-dhp-diwali" *ngIf="isLive">Diwal<span class="ipm-dhp-anar">i<span class="ipm-dhp-anar-glow"></span><span class="ipm-dhp-anar-spark" *ngFor="let spark of anarSparks"
                [style.--dx]="spark.dx + 'px'" [style.--dy]="spark.dy + 'px'" [style.animation-delay.s]="spark.delay" [style.animation-duration.s]="spark.duration"
                [style.width.px]="spark.size" [style.height.px]="spark.size" [style.background]="spark.color"></span></span></span>
            <span class="ipm-dhp-brand">Sale</span>
            <span class="ipm-dhp-lamp">🪔</span>
        </h2>
        <p class="ipm-dhp-sub">{{tagline}}</p>
    </div>

    <div class="ipm-dhp-countdown" *ngIf="label" [class.is-live]="isLive">
        <div class="ipm-dhp-cd-label"><i class="pi pi-clock"></i><span>{{label}}</span></div>
        <div class="ipm-dhp-cd-nums">
            <ng-container *ngFor="let part of parts; let last = last">
                <div class="ipm-dhp-cd-unit">
                    <div class="ipm-dhp-cd-n">{{part.value}}</div>
                    <div class="ipm-dhp-cd-lbl">{{part.label}}</div>
                </div>
                <div class="ipm-dhp-cd-sep" *ngIf="!last">:</div>
            </ng-container>
        </div>
        <div class="ipm-dhp-period" *ngIf="startAt && endAt">
            <span class="ipm-dhp-period-lbl">Sale Period</span>
            <span class="ipm-dhp-period-val">{{startAt | date : 'd MMM'}} – {{endAt | date : 'd MMM y'}}</span>
        </div>
    </div>

    <div class="ipm-dhp-tracks" *ngIf="displayTracks.length > 0">
        <div class="ipm-dhp-tracks-label">
            <span>🎵</span> 10,000+ Tracks Enabled. 450M+ Streams Generated
            <span class="ipm-dhp-line"></span>
        </div>
        <div class="ipm-dhp-scroll" ipmDragScroll #scroller (mouseenter)="pauseAutoScroll(true)" (mouseleave)="pauseAutoScroll(false)" (touchstart)="pauseAutoScroll(true)" (touchend)="pauseAutoScroll(false)">
            <div class="ipm-dhp-card" *ngFor="let beat of displayTracks; trackBy: trackById" [class.ipm-dhp-card--link]="beat?.serial_number" (click)="goToBeat(beat)">
                <div class="ipm-dhp-thumb">
                    <span class="ipm-dhp-abbr" *ngIf="beat?.title">{{trackAbbr(beat)}}</span>
                    <img *ngIf="beat?.cover_picture" [src]="beat.cover_picture" [alt]="beat?.title" loading="lazy">
                    <span class="ipm-dhp-disc" *ngIf="commonService.isBeatOnSale(beat)">{{beat?.sale_info?.discount_tier}}%</span>
                    <span class="ipm-dhp-play" *ngIf="beat?.serial_number"><i class="fa fa-play"></i></span>
                </div>
                <div class="ipm-dhp-card-title" *ngIf="beat?.title">{{beat?.title}}</div>
                <div class="ipm-dhp-card-prod" *ngIf="beat?.title">{{beat?.producer?.store?.general?.name}}</div>
            </div>
        </div>
    </div>
</div>
